import React from "react";
import {Breadcrumbs as MuiBreadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";

const Breadcrumbs = (props) => {
    const {selectedFilters = []} = props;

    let inserts = '';
    let breadcrumbsList = selectedFilters.filter((el) => {
        if (
            el.key === 'category' ||
            el.key === 'view' ||
            (el.key === 'inserts' && inserts === '') ||
            el.key === 'metal' ||
            el.key === 'sex'
        ) {
            if (el.key === 'inserts') {
                inserts = el.value;
            }
            return el;
        }
    });

    let url = '';
    let breadcrumbs = breadcrumbsList.map((el, i) => {
        if (i + 1 !== breadcrumbsList.length) {
            url += `/${el.valueAlias}`;

            return <Link key={i} className={`breadcrumbs__link`} href={`/catalog${url}`}>
                {el.value}
            </Link>
        } else {
            return <div key={i} className={`breadcrumbs__text`}>{el.value}</div>
        }
    });

    return (
        <MuiBreadcrumbs maxItems={4} itemsAfterCollapse={3} className={`breadcrumbs`}>
            <Link className={`breadcrumbs__link`} href={`/catalog`}>Каталог</Link>
            {breadcrumbs}
        </MuiBreadcrumbs>
    );
}

export default Breadcrumbs;
